import {DatePicker, LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns";
import {Grid2 as Grid} from "@mui/material";
import React from "react";

interface FormDateRangeProps {
  prefix?: string;
  suffix?: string;
  locale: Locale;
  labels: string[];
  values: Record<string, any>;
  onChange: (name: string, value: any) => void;
  required?: boolean
}

export default function FormDateRange({
  prefix = "",
  suffix = "",
  values,
  labels,
  locale,
  onChange,
  required=false,
}: FormDateRangeProps) {
  const beginName = prefix + "begin" + suffix;
  const endName = prefix + "end" + suffix;

  return <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={locale}>
    <Grid container spacing={2} size={12}>
      <Grid size={{xs:12, sm:12, md:6}}>
        <DatePicker
          label={labels[0]}
          value={values[beginName]}
          onChange={(value) => value && onChange(beginName, value)}
          slotProps={{textField: {fullWidth: true, required, InputLabelProps: {shrink: true}}}}/>
      </Grid>
      <Grid size={{xs:12, sm:12, md:6}}>
        <DatePicker
          label={labels[1]}
          value={values[endName]}
          onChange={(value) => value && onChange(endName, value)}
          slotProps={{textField: {fullWidth: true, required, InputLabelProps: {shrink: true}}}}/>
      </Grid>
    </Grid>
  </LocalizationProvider>;
}
